// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./testvehicleslots.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var moment = require("moment");

// the regExp to find testvehicleslots-module
var parseRe = /\[testvehicleslots(\*|)\]/gi;

var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).testvehicleslots;
var parsing = require('parsing').testvehicleslots;
var moduleHelper = require('../../scripts/module-helper');

var calendarRenderer = require('./testvehicleslots-calendar-renderer');

// the default required settings, should be set during parse
var defaultRequired = false;

// This happens before rendering and prepares the html
function parse(text, next) {

    strip(require('raw!./testvehicleslots.html'), function (outputHtml) {
        parseRe.lastIndex = 0; // reset the regexp state

        var match = parsing.parse(text);
        defaultRequired = false;

        if (match) {
            if (match[1] == "*") {
                var container = document.createElement("div");
                container.innerHTML = outputHtml;

                var domObj = container.firstChild;

                var input = domObj.getElementsByTagName("input")[0];
                input.setAttribute("data-required", "true");

                // add a "required" class to the parent node
                domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                required = defaultRequired = true;

                outputHtml = container.innerHTML;
            }
            else {
                required = defaultRequired = false;
            }

            text = text.replace(match[0], outputHtml);
        }

        next(text);
    });

};

// Validation function
function validate(context, err, forceRequired) {
    return true;
}

// This happens when Generic Forms renders the first time at load
function init(formRoot, formData, next) {

    var field = formRoot.querySelector("#testvehicleslots-field");
    var context = formRoot.querySelector('[data-module="testvehicleslots"]');

    if (formData && formData.prefill && field) {
        field.value = formData.prefill.testvehicleslots || '';
    }

    if (context) {

        var input = context.querySelector("input");

        if (formData.form && formData.form.testdrive && formData.form.testdrive.enabled) {

            var startDate = moment(formData.form.testdrive.startDate);
            var endDate = moment(formData.form.testdrive.endDate);
            var openHour = formData.form.testdrive.openHour;
            var closeHour = formData.form.testdrive.closeHour;
            var slotLength = formData.form.testdrive.slotLength;
            var unavailable = formData.form.testdrive.unavailable;
            var openTime = moment(openHour, 'HH:mm');
            var closeTime = moment(closeHour, 'HH:mm');

            startDate.set({ hour: openTime.get('hour'), minute: openTime.get('minute'), });
            endDate.set({ hour: closeTime.get('hour'), minute: closeTime.get('minute'), });

            calendarRenderer.renderCalendar(formRoot, context, formData.testvehicleslots.cars, startDate, endDate, slotLength, unavailable, function(key) {
                input.value = key;
            });

            // Expose validate and get so that other modules can access the data
            context.validate = function (forceRequired) {
                return validate(context, null, forceRequired);
            }
            context.get = function () {
                return get(context);
            }

            moduleHelper.fields.text.bindValidationEvents(context, validate);

        }

    }

    next(formRoot);

}

// This gets the current value. Its used for getting the data before submit or if other
// module are dependent on this one
function get(context) {
    var input = context.querySelector("input");
    var value = input.value;
    return value;
}

// Clear everything. This is usually happens after submit
function reset(context) {
    var input = context.querySelector("input");
    input.value = '';
}

// This checks if this module acually exists in the form
function exists(context) {
    var exists = true;
    var markdownMatch = false;
    if (context != null && context.innerHTML != null) {
        parseRe.lastIndex = 0; // reset the regexp
        var match = parseRe.exec(context.innerHTML);
        markdownMatch = (context.innerHTML != null && match != null && (match[0] == "[testvehicleslots]" || match[0] == "[testvehicleslots*]"));
    }
    var input = null;
    if (context != null) {
        input = context.querySelector("input");
    }
    exists = exists && (input != null || markdownMatch);
    return exists;
}

module.exports = {
    parse: parse,
    validate: validate,
    init: init,
    get: get,
    reset: reset,
    exists: exists
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/testvehicleslots/testvehicleslots.js